import { render } from "./ModifierMaterial.vue?vue&type=template&id=7b62f4e4"
import script from "./ModifierMaterial.vue?vue&type=script&lang=js"
export * from "./ModifierMaterial.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__